import { SessionData, SessionState, State } from '../../../types'

export const SET = 'session//SET'

export interface SetSessionAction {
  type: typeof SET
  payload: SessionData
}

export type SessionAction = SetSessionAction

export function setSession(data: SessionData): SetSessionAction {
  return {
    type: SET,
    payload: data,
  }
}

export function getSession(store: State): SessionData {
  return store.session.data
}

const initialState: SessionState = {
  data: { pin: '' },
}

export default function sessionReducer(
  state: SessionState = initialState,
  action: SessionAction
): SessionState {
  switch (action.type) {
    case SET:
      return {
        ...state,
        data: action.payload,
      }
    default:
      return state
  }
}
